export default "__VITE_ASSET__BTjBNqcE__"